import { useOnline } from '@vueuse/core';

export default defineNuxtRouteMiddleware(() => {
  const online = useOnline();
  const { $i18n } = useNuxtApp();
  if (import.meta.client) {
    if (!online.value) {
      // eslint-disable-next-line no-alert
      alert($i18n.t('errors.offline'));
      window.location.reload();
    }
  }
});
